<template>
  <div class="gallery-slider">
    <!-- Placeholder section -->
    <template v-if="!images.length">
      <div class="gallery-slider__placeholder">
        <span class="image-loader">
          <loading-spinner :size="24" />
        </span>
      </div>
    </template>
    <!-- With images section -->
    <template v-if="images.length">
      <div class="gallery-slider__slides">
        <splide
          v-if="images.length"
          class="gallery-slider__stage"
          :options="primaryOptions"
          ref="primary"
        >
          <splide-slide v-for="(slide, idx) in images" :key="idx">
            <div class="gallery-slider__image">
              <img
                :data-splide-lazy="slide.txt"
                @error="imageLoadError"
                alt=""
              />
            </div>
          </splide-slide>
        </splide>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "gallery-slider",
  props: {
    images: Array
  },
  data: () => ({
    primaryOptions: {
      type: "loop",
      lazyLoad: "nearby",
      preloadPages: 2,
      pagination: false
    },
    defaultImage: "https://www.travelone.pl/newimgs/zaslepka_lato.jpg"
  }),
  methods: {
    imageLoadError(e) {
      e.target.src = this.defaultImage;
    }
  }
};
</script>

<style lang="scss" scoped>
.gallery-slider {
  &,
  &__placeholder {
    height: 66vw;
    max-height: 300px;
    position: relative;

    @media (min-width: $screen-xs) {
      height: 380px;
      max-height: none;
    }
  }

  &__stage {
    height: 100%;
  }

  &__slides {
    height: 100%;
    overflow: hidden;
  }

  &__image {
    background-color: $gray-00;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 100%;

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
    }
  }
}

::v-deep .gallery-slider {
  &__stage {
    .splide__slide,
    .splide__track,
    .splide__list {
      height: 100%;
    }

    .splide__arrow {
      background-color: transparent;

      svg {
        fill: #fff;
      }
    }

    .splide__arrow--prev {
      left: 12px;
    }

    .splide__arrow--next {
      right: 12px;
    }

    .splide__spinner {
      border-color: $blue-light;
      border-left-color: transparent;
      width: 24px;
      height: 24px;
      z-index: 2;
    }
  }
}

.image-loader {
  background-color: $gray-00;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  transition: opacity 0.2s ease-in-out;

  &._hiding {
    opacity: 0;
  }
}
</style>
